<template>
  <div class="attribute-wrapper"
    :is-firefox="isFirefox()"
    :prefers-reduced-motion="prefersReducedMotion()"
  >
    <slot/>
  </div>
</template>

<script>
  export default {
    name: 'AttributeWrapper',

    methods: {
      isFirefox() {
        return typeof InstallTrigger !== 'undefined';
      },

      prefersReducedMotion: function() {
        return this.$root.ui.prefersReducedMotion.userSetting || this.$root.ui.prefersReducedMotion.force;
      },
    },

    mounted() {
      // Получаем системные настройки уменьшения движения
      const motionQuery = matchMedia('(prefers-reduced-motion)');
      const that = this;
      motionQuery.addListener(function() {
        that.$root.ui.prefersReducedMotion.userSetting = motionQuery.matches;
      });
      that.$root.ui.prefersReducedMotion.userSetting = motionQuery.matches;

      // Анимации очень тормозят в Firefox, поэтому в нём отключаем по умолчанию
      if(this.isFirefox()) {
        this.$root.ui.prefersReducedMotion.force = true;
      }
    }
  };
</script>

<style lang="less" scoped>
  .attribute-wrapper {
    height: 100%;
  }
</style>
